// LeadsListMobile.tsx
import { IonList, IonItem, IonLabel, IonNote } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { contactAdapter } from "../../../utils/contacts";
import { Settings } from "../../../interfaces";

interface Props {
  contacts: any;
  settings: Settings;
  handleClick: (id: string) => void;
}

const LeadsListMobile: React.FC<Props> = ({
  contacts,
  settings,
  handleClick,
}) => {
  if (!contacts?.length) {
    return (
      <IonList lines="none">
        <IonItem>
          <FormattedMessage id="common.noResults" />
        </IonItem>
      </IonList>
    );
  }

  return (
    <IonList inset={false}>
      {contacts.map((raw: any) => {
        const contact = contactAdapter(raw, {});
        const { manual, blocked, name, phoneNumber, timestampHour, score } =
          contact;

        /* Construimos el “badge” de score */
        const scoreBadge = (
          <span
            className={classNames("badge", {
              "text-bg-danger": score === 1,
              "text-bg-warning": score === 2 || score === 3,
              "text-bg-light": score === 4 || score === 5 || !score,
            })}
          >
            {score || 5}
          </span>
        );

        /* Badges mini para estados especiales */
        const flags = (
          <>
            {raw.escalated && (
              <div className="badge text-bg-warning">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div className="fw-semibold-1">
                    <FormattedMessage id="esc.needsReview" />
                  </div>
                </div>
              </div>
            )}
            {manual && (
              <div className="badge text-bg-info">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div className="fw-semibold-1">
                    <FormattedMessage id="chats.manual" />
                  </div>
                </div>
              </div>
            )}
            {blocked && (
              <div className="badge text-bg-danger">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div className="fw-semibold-1">
                    <FormattedMessage id="chats.blocked" />
                  </div>
                </div>
              </div>
            )}
          </>
        );

        return (
          <IonItem
            key={raw._id}
            button
            detail={true}
            onClick={() => handleClick(raw._id)}
          >
            {/* Contenido principal */}
            <IonLabel className="ion-text-wrap">
              <h2 className="d-flex align-items-center gap-1">
                {name || phoneNumber} {scoreBadge}
              </h2>
              {/* Hora + flags */}
              <div className="d-flex align-items-center gap-1">
                {timestampHour} {flags}
              </div>
              {/* Empresa (opcional si hay varias) */}
              {settings.companies.length > 1 && (
                <IonNote color="medium" className="d-block">
                  {raw.companies.map((c: any) => c.name).join(", ")}
                </IonNote>
              )}
            </IonLabel>
          </IonItem>
        );
      })}
    </IonList>
  );
};

export default LeadsListMobile;
